import carouselNav from "../nav/colourCorouselNav";
import carouselPaging from "../nav/carouselPaging";
import MediaLibrary from "../upload/MediaLibrary";
import EvidenceUploader from "../upload/EvidenceUploader";
import PreventFormDataLoss from "../security/preventFormDataLoss";
import AssessmentTour from "../components/AssessmentTour";
import reportValidation from "../reports/reportValidation";
import ReportTodoList from "../reports/ReportTodoList";
import { __ } from "../util/dom";
import UploadModal from "../components/UploadModal";
import MediaSelectableItem from "../components/MediaSelectableItem";
import RichEditor from "quill";
import { toast } from "materialize-css";
import axios from "axios";
import { responsesNoChangeInit } from "../reports/questions";
import { updateValidateButtonDisabledStatus } from "../reports/reportValidation";

let preventReportFormDataLoss = null;

export default function handleSectionsPage(requestFromPath) {
    // when showing progress report we only have to load js code for rich text editor
    if (~requestFromPath.indexOf("/progress")) richEditorsInit();
    else {
        $(".modal").modal();

        // when they click the customer lock switch, click the submit button
        // $('#customer-lock-switch').click(evt => $('#customer-lock-button').click());

        MediaLibrary.registerDefaultMediaItemGenerator((media) =>
            new MediaSelectableItem(media).loadFromDom()
        );
        MediaLibrary.load(".media");

        carouselInit();
        richEditorsInit();
        ratingSelectionInit();
        commentBoxInit();
        carouselPaging();
        reportValidation();
        preventReportFormDataLoss = new PreventFormDataLoss("#carousel-form");
        confirmOnAssessmentLocked();
        saveDraftButtonInit();
        formChangeInit();
        responsesNoChangeInit();

        new ReportTodoList();

        // setup uploader modal, service and evidence uploaders
        const uploadModal = new UploadModal();
        Array.from(__(".evidence-container")).forEach(
            (container) => new EvidenceUploader(uploadModal, container)
        );

        const tourStatus = localStorage.getItem(
            "assessmentServicesTourStatus-" + $("#tour-id-number").val()
        );
        if (!tourStatus || tourStatus !== "stop") {
            AssessmentTour.start();
        }

        // allow the tour to start whenever they click help
        $("#tour-on-demand").on("click", (evt) => AssessmentTour.start());
    }
}

// this function will check if the assessment is locked for customer and triggers a confirm dialog when user tries to navigate to another page
function confirmOnAssessmentLocked() {
    let lockInput = document.querySelector(
        '#customer-lock-switch input[type="checkbox"]'
    );
    if (lockInput && lockInput.getAttribute("checked") === "checked") {
        let linksInSideNav = document.querySelectorAll(".side-nav a");
        for (let linkInSideNav of linksInSideNav) {
            linkInSideNav.addEventListener("click", function (event) {
                {
                    let userInput = confirm(
                        "Are you sure that you want to leave the Assessment locked or unsaved\n" +
                            "If you want to leave the page press OK otherwise press Cancel"
                    ); // confirm() returns true or false
                    if (userInput === false) {
                        event.preventDefault();
                    } else {
                        // set this true, so that the prompt for unsaved changes doesn't show afterwards `preventFormDataLoss()`
                        preventReportFormDataLoss.pause();
                    }
                }
            });
        }
    }
}

function richEditorsInit() {
    let richEditorEls = document.querySelectorAll(".rich-editor-readonly");
    for (let richEditorEl of richEditorEls) {
        let richEditor = new RichEditor(richEditorEl, {
            theme: "bubble",
            readOnly: true,
        });

        let sectionTitle = richEditorEl.getAttribute("data-section-title");
        let sectionTitleDelta = JSON.parse(
            richEditorEl.getAttribute("data-section-title-delta")
        );

        // check if it is a valid quill delta
        if (sectionTitleDelta != null && sectionTitleDelta.ops !== undefined) {
            richEditor.setContents(sectionTitleDelta);
        } else richEditor.setText(sectionTitle);

        // let sectionId = richEditorEl.id.replace('title-', '');
        // allRichEditors[sectionId] = richEditor;
    }
    // remove the materialize css on the select for quill editor
    $("select.ql-header").addClass("browser-default");
}

function carouselInit() {
    // handle carousel init
    $(".carousel").carousel({ fullWidth: true });
    // class controls the proper height of the carousel
    document
        .getElementById("carousel-form")
        .classList.add("carousel-pages-form");
}

function ratingSelectionInit() {
    // setup our variables;
    const trigger = $(".rating-group:first-child .rating-trigger");
    const modal = $("#rating-modal");
    const radios = modal.find("input");
    const colourList = radios
        .toArray()
        .map((radio) => radio.getAttribute("data-colour"));

    // check if we should continue from this point
    if (!modal.length || !trigger.length) {
        console.log("Safe check failure", {
            modalLength: modal.length,
            triggerLength: trigger.length,
        });
        carouselNav(colourList);
        return;
    }

    carouselNav(colourList);

    // used to track which trigger was used to toggle the modal
    let lastTrigger = null;

    // setup event binding

    trigger.click((evt) => {
        lastTrigger = $(evt.currentTarget);
        modal.modal("open");
    });

    radios.click((evt) => {
        const target = evt.currentTarget;
        const schemeId = target.getAttribute("data-value");
        const schemeName = target.getAttribute("data-value-name");
        const colour = target.getAttribute("data-colour");

        lastTrigger.removeClass(colourList.join(" ")).addClass(colour);

        lastTrigger.parent().find(".rating-name").text(schemeName);

        // update form field
        const parent = lastTrigger.closest(".col");
        if (parent.length) {
            parent.find("input").val(schemeId);
            parent.find("input").trigger("change");

            // validate report status to change status of buttons
            updateValidateButtonDisabledStatus();
        }

        // clear the fields
        radios.prop("checked", false);
        modal.modal("close");

        // reload the nav
        carouselNav(colourList);
    });
}

function commentBoxInit() {
    const csrfToken = $("meta[name=csrf-token]").attr("content");
    const modal = $("#add-comment-modal");
    const field = $("#comment-field");
    const reportId = $("#report-id").val();

    let lastQuestion;

    $("button[data-target=add-comment-modal]").click((evt) => {
        lastQuestion = evt.currentTarget.getAttribute("data-question");
    });

    modal.find(".post-comment").click((evt) => {
        const currentTarget = evt.currentTarget;
        currentTarget.setAttribute("disabled", true); // disable the button as soon as possible

        const comment = field.val();
        const data = {
            report_id: reportId,
            question_id: lastQuestion,
            action_url: window.location.href,
            comment,
            _token: csrfToken,
        };

        $.post("/api/add-comment", data, (res) => {
            // clear the modal field
            field.val("");

            // Add the comment to the UI
            $(`#comment-list-${lastQuestion}`).append(
                $("<div>")
                    .addClass("comment")
                    .append($("<span>").addClass("by").text("You"))
                    .append($("<div>").text(comment))
            );

            modal.modal("close");
        })
            .fail(() =>
                Materialize.toast(
                    "[ERROR] Could not post comment at this time. Try refreshing your page",
                    5000
                )
            )
            .always(() => currentTarget.removeAttribute("disabled"));
    });
}

let saveDraftButton = null;

function saveDraftButtonInit() {
    saveDraftButton = document.querySelector("#save-draft-button");

    if (saveDraftButton) {
        // button will be disabled in start as no changes yet
        saveDraftButton.setAttribute("disabled", true);

        // click event won't trigger when the button has 'disabled' attribute
        saveDraftButton.addEventListener("click", (event) => {
            // stop the auto save timeout, when user click on save manually
            clearTimeout(autoSaveTimeout);
            saveReport(false);
        });
    }
}

const saveDraftButtonStates = {
    SAVE_DRAFT_ENABLED: 1,
    SAVE_DRAFT_DISABLED: 2,
    AUTOSAVED_ENABLED: 3,
};
function saveDraftButtonStateChangedTo(newState) {
    if (newState === saveDraftButtonStates.SAVE_DRAFT_DISABLED) {
        saveDraftButton.textContent = "SAVE DRAFT";
        saveDraftButton.setAttribute("disabled", null);
    } else if (newState === saveDraftButtonStates.SAVE_DRAFT_ENABLED) {
        saveDraftButton.textContent = "SAVE DRAFT";
        saveDraftButton.removeAttribute("disabled");
    } else if (newState === saveDraftButtonStates.AUTOSAVED_ENABLED) {
        saveDraftButton.textContent = "AUTOSAVED";
        saveDraftButton.setAttribute("disabled", null);
    }
}

let autoSaveTimeout = null;
function formChangeInit() {
    // any form change will trigger autosave
    $("#carousel-form").on("change", ":input", function () {
        //':input' selector get all form fields even textarea, input, or select
        if (saveDraftButton) {
            saveDraftButtonStateChangedTo(
                saveDraftButtonStates.SAVE_DRAFT_ENABLED
            );
            saveReport(true);
            saveFormField(this);

            /* commented timeout code
            // lets auto save after 10 secs
            // first check if timer is already running, then no need to set again
            if (!autoSaveTimeout) {
                autoSaveTimeout = setTimeout(() => {
                    saveReport(true);
                    autoSaveTimeout = null;
                }, 10000);
            }
            */
        }
    });
}

async function saveFormField(field) {
    const organizationId = document.querySelector("#organization-id").value;
    const reportId = document.querySelector("#report-id").value;
    const fieldId = field.name;
    const fieldValue = field.value;

    saveDraftButtonStateChangedTo(saveDraftButtonStates.SAVE_DRAFT_DISABLED);

    const response = await axios.post("/api/update-report-field", {
        organization_id: organizationId,
        report_id: reportId,
        field_id: fieldId,
        [fieldId]: fieldValue,
    });

    preventReportFormDataLoss.resetInitialState();
    console.log("response received", response.json());
}

function saveReport(isAutoSave) {
    let carouselForm = document.querySelector("form#carousel-form");

    let organizationId = document.querySelector("#organization-id").value;
    let reportId = document.querySelector("#report-id").value;
    let carouselFormData = new FormData(carouselForm);

    saveDraftButtonStateChangedTo(saveDraftButtonStates.SAVE_DRAFT_DISABLED);
    axios
        .post(
            "/api/" + organizationId + "/report/" + reportId,
            carouselFormData,
            { responseType: "json" }
        )
        .then(function (response) {
            preventReportFormDataLoss.resetInitialState();
            if (isAutoSave) {
                saveDraftButtonStateChangedTo(
                    saveDraftButtonStates.AUTOSAVED_ENABLED
                );
            } else {
                toast("Draft Saved", 5000);
            }
        })
        .catch(function (error) {
            if (error.message) {
                // console.log(error.message);
            }
            toast(
                "[Error] There was a problem while saving the draft. Please refresh the page and try again",
                5000
            );
        });
}

//
// function ajaxCarouselForm (type, url, jQueryFormEl)
// {
//     return $.ajax({
//         url: url,
//         type: 'post',
//         data: jQueryFormEl.serialize(),
//         dataType: 'json'
//     })
// }
